import script from "./ViolationDetailsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ViolationDetailsModal.vue?vue&type=script&setup=true&lang=js"

import "./ViolationDetailsModal.vue?vue&type=style&index=0&id=f72f9c5e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f72f9c5e"]])

export default __exports__